import { useState, useEffect } from "react";
import { Package } from "lucide-react";
import api from "../../lib/api";
import { getIngredientDisplayImage } from "./inventoryConstants";

export function LazyIngredientImage({ ingredient, className }) {
  const [src, setSrc] = useState(null);
  const [tried, setTried] = useState(false);
  const fallback = getIngredientDisplayImage(ingredient);

  useEffect(() => {
    if (fallback && fallback !== "__lazy__") {
      setSrc(fallback);
      setTried(true);
    } else if (!tried) {
      api.getIngredientImage(ingredient.ingredient_id)
        .then(data => { if (data?.image_url) setSrc(data.image_url); })
        .catch(() => {})
        .finally(() => setTried(true));
    }
  }, [ingredient.ingredient_id]); // eslint-disable-line

  if (!src) return (
    <div className={`${className} bg-muted flex items-center justify-center`}>
      <Package className="w-5 h-5 text-muted-foreground/40" />
    </div>
  );
  return <img src={src} alt={ingredient.name} className={`${className} object-cover`} />;
}
